import { BrowserRouter } from "react-router-dom";
import Accueil from "./public/pages/Accueil/Accueil.tsx";
import { AppProvider } from "./app/components/App/AppProvider.tsx";
import "./fonts/fonts.module.css";
import "././app/variable.module.css";
import "./Index.module.css";
import { MainContainer } from "./app/components/Elements/Elements.tsx";
import "./style.scss";

/**
 * Contient les pages publics du site, où le userInfo n'est pas forcément renseigné
 */
const Index = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        <MainContainer>
          <Accueil />
        </MainContainer>
      </AppProvider>
    </BrowserRouter>
  );
};
export default Index;
